export default "__VITE_ASSET__b9QYWhqU__"